module.exports = __webpack_public_path__ + "static/media/ahi-pi-not-subscribed.dd4b2e01.svg";